import { AffiliationErrorTypeEnum } from "waapi/palpatine-client/entities/AffiliationError/AffiliationError.enum.js";
import { CustomTFunction, TranslationDictionary } from "../../../customHooks/useTranslation/types.js";
import { errorTypeTexts } from "../constants/errorTypeTexts.js";

export const getErrorTypeText = (params: {
    errorType: AffiliationErrorTypeEnum;
    t: CustomTFunction;
    translations: TranslationDictionary;
}): string => {
    const { errorType, t, translations } = params;

    return errorTypeTexts({ t, translations })[errorType];
};
